export default "__VITE_ASSET__CpuwGGwI__"